import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage-angular";
import { ArrayStorageRepository } from "./abstract/array.storage.repository";
import { ProcessedLog } from "../types/Log/ProcessedLog";

@Injectable({
  providedIn: "root",
})
export class LogRepository extends ArrayStorageRepository<ProcessedLog> {
  constructor(storage: Storage) {
    super(storage, "logs", "logID");
  }
}
